import React from 'react';
import { Col, FormGroup, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Switch, CheckBox, EmailBox, TextBox } from 'fw/forms';
import { ActionButton, Label, Remark, Button } from 'fw/components';
import { RoleMultiselect, PhoneBox, Address, UserTypeCombo, CompanyMultiselect, SponsorMultiselect } from 'areas/shared/controls'
import { SetupTab } from 'areas/shared/pages/setup';
import * as ReportManager from 'modules/reports/ReportManager';
import * as Modals from 'fw/globals/Modals';
import * as App from 'modules/app/App';
import * as API from 'modules/app/API';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import CompanyAssociationPopUp from './CompanyAssociationPopUp';

class UserInfoTab extends SetupTab {
    initialState() {
        return {
            activeInitialValue: false,
            changedToInactive: false,
            showCompanyAssociationPopUp: false
        };
    }

    initialForm() {
        return {
            login: "",
            email: "",
            fullName: "",
            firstName: "",
            lastName: "",
            primaryPhone: "",
            secondaryPhone: "",
            active: true,
            registrationPending: true,
            blocked: true,
            roles: [],
            companies: [],
            subscribedCompanies: [],
            rowVersion: null,
            userTypeCode: "ADM",
            userSubscribed: true
        }
    }

    privileges() {
        return {
            add: App.hasPrivilege("AdminUserSetupAdd"),
            edit: App.hasPrivilege("AdminUserSetupEdit")
        }
    }

    urls() {
        return {
            get: API.Security.url('/userSetup/getUserInfo'),
            save: API.Security.url('/userSetup/saveUserInfo'),
            create: API.Security.url('/userSetup/createUser')
        }
    }

    getRequest(selectedId) {
        return {
            userId: selectedId
        }
    }

    saveRequest() {
        return {
            userId: this.props.selectedId,
            login: this.state.form.login,
            email: this.state.form.email,
            firstName: this.state.form.firstName,
            lastName: this.state.form.lastName,
            primaryPhone: this.state.form.primaryPhone,
            secondaryPhone: this.state.form.secondaryPhone,
            active: this.state.form.active,
            roles: this.state.form.roles,
            companies: this.state.form.companies,
            subscribedCompanies: this.state.form.subscribedCompanies,
            address: this.state.form.address,
            userTypeCode: this.state.form.userTypeCode,
            rowVersion: this.state.form.rowVersion,
            userSubscribed: this.state.form.userSubscribed
        }
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
        this.state.activeInitialValue = this.state.form.active;
    }

    beforeSave = () => {
        const me = this;
        const form = this.state.form;
        // If this is the last associated user and was set as Inactive
        if (form.lastAssociatedUser && this.state.activeInitialValue && !form.active ){
            Modals.confirm(
                "Warning! As this is the only remaining User associated with one of their companies, marking this User as Inactive will also mark that Company as Inactive. <br /><br />" +
                "If you wish to Inactivate the User and Save, please select 'Yes'. <br /><br />" +
                "If you wish to Discard this change, please select 'No', and you will be returned to the previous screen.",
                function () {
                    me.save();
            });
        }
        else
            me.save();  
    }

    handleDelete = () => {
        const me = this;

        Modals.remove({
            title: "Deleting user",
            elementType: "user",
            name: this.state.form.fullName,
            onYes: () => {
                API.Security.post('/userSetup/deleteUser', { userId: me.props.selectedId },
                    {
                        success: (r) => {
                            me.props.onSuccess(r.message);
                            me.props.onDelete();
                        },
                        error: (r) => {
                            me.props.onError(r.error);
                        }
                    });
            }
        });
    }

    handleResendRegistration = () => {
        const me = this;

        Modals.confirm("This will resend the registration email for this user. Are you sure?", function () {
            API.Security.post('/registration/resendRegistration', { userId: me.props.selectedId }, {
                success: (r) => {
                    me.props.onSuccess(r.message);
                },
                error: (r) => {
                    me.props.onError(r.error);
                }
            });
        });
    }

    handleUnblockUser = () => {
        const me = this;

        API.Security.post('/userSetup/unblockUser', { userId: me.props.selectedId }, {
            success: (r) => {
                me.props.onSuccess(r.message);
                let f = this.state.form;
                f.blocked = false;
                this.setState({ form: f });
            },
            error: (r) => {
                me.props.onError(r.error);
            }
        });
    }

    handleResetPassword = () => {
        const me = this;

        Modals.confirm("An email will be sent to the user that will contain a link to reset their password.  Do you wish to proceed?", function () {
            API.Security.post('/userSetup/resetUserPassword', { userId: me.props.selectedId }, {
                success: (r) => {
                    me.props.onSuccess(r.message);
                },
                error: (r) => {
                    me.props.onError(r.error);
                }
            });
        });
    }
    

    handlePrint = () => {
        const rq = Object.assign({
            reportType: 'UserInfoReport',
            format: 'PDF',
            parameters: {
                userId: this.props.selectedId
            }
        });

        ReportManager.execute(rq);
    }

    handleAddressChange = (address) => {
        let form = this.state.form;
        form.address = {
            addressId: address.addressId,
            street1: address.street1,
            street2: address.street2,
            zip: address.zip,
            city: address.city,
            stateCode: address.stateCode,
            county: address.county,
            province: address.province,
            countryCode: address.countryCode
        }

        this.setState({ form });
    }

    handleSendTestSMS = () => {
        const me = this;

        Modals.confirm("This will send a test SMS to this user. Are you sure?", () => {
            API.Security.get('/userSetup/sendTestSMS', { userId: me.props.selectedId }, {
                success: (r) => {
                    me.props.onSuccess(r.message);
                },
                error: (r) => {
                    me.props.onError(r.error);
                }
            });
        });
    }

    renderActions() {
        if (this.state.adding)
            return null;

        return (
            <div className="pull-right">
                <ActionButton id="btnPrint" onClick={this.handlePrint} icon="print">Print</ActionButton>

                {(App.hasPrivilege("AdminUserSetupReset") && this.state.form.registrationPending) &&
                    <ActionButton id="btnResendRegistration" onClick={this.handleResendRegistration} icon="envelope">Resend Registration</ActionButton>
                }
                {(App.hasPrivilege("AdminUserSetupReset") && this.state.form.blocked) &&
                    <ActionButton id="btnUnblockUser" onClick={this.handleUnblockUser} icon="lock">Unblock User</ActionButton>
                }
                {(App.hasPrivilege("AdminUserSetupReset") && this.state.form.original.active && !this.state.form.registrationPending) &&
                    <ActionButton id="btnResetPassword" onClick={this.handleResetPassword} disabled={this.state.form.registrationPending} icon="envelope">Reset Password</ActionButton>
                }
                {App.hasPrivilege("AdminUserSetupReset") &&
                    <ActionButton id="btnSendTestSMS" onClick={this.handleSendTestSMS} icon="send" disabled={this.state.dirty}>Send Test SMS</ActionButton>
                }
                {App.hasPrivilege("AdminUserSetupDelete") && this.state.form.original.registrationPending &&
                    <ActionButton id="btnDeleteUser" onClick={this.handleDelete} icon="trash">Delete User</ActionButton>
                }
            </div>
        )
    }

    onCompanyAssociationClose = () => {
        this.setState({
            showCompanyAssociationPopUp: false
        });
    }
 
    onCompanyAssociationClick = () => {
        this.setState({
            showCompanyAssociationPopUp: true
        });
    }

    onCompanyAssociationAdd = (data) => {
        let form = this.state.form;
        
        form.companies = data.companies;
        form.associatedCompanies = data.associatedCompanies;
        form.subscribedCompanies = data.subscribedCompanies;
        form.subscribedAssociatedCompanies = data.subscribedAssociatedCompanies;

        this.setState({ form });
    }

    renderForm() {
        const loginTooltip = (
            <Tooltip id="loginTooltip">
                Should contain between 8 and 20 characters, and no spaces.<br />
                Can contain letters, numbers and special chars including: !@#$%&*()._-+=<br />
            </Tooltip>
        );

        const sponsorUnsubscribedTooltip = (
            <Tooltip id="sponsorUnsubscribedTooltip">
                Email notifications have been disabled at Corporate Member level.
            </Tooltip>
        );

        return (
            <React.Fragment>
                <Row>
                    <Col md={4}>
                        <FormGroup>
                            <Label required>First Name</Label>
                            <TextBox
                                name="firstName"
                                placeholder="First Name"
                                maxLength={30}
                                required
                                ref={(c) => { this.focusControl = c; }} />
                        </FormGroup>
                        <FormGroup>
                            <Label required>Last Name</Label>
                            <TextBox
                                name="lastName"
                                placeholder="Last Name"
                                maxLength={30}
                                required />
                        </FormGroup>
                        <FormGroup>
                            <Label required>Login ID</Label>
                            &nbsp;&nbsp;
                            <OverlayTrigger placement="right" overlay={loginTooltip}>
                                <FontAwesomeIcon icon={faInfoCircle} size="1x" className="tooltipIcon" />
                            </OverlayTrigger>
                            <TextBox
                                name="login"
                                placeholder="Login ID"
                                maxLength={30}
                                required />
                        </FormGroup>
                        <FormGroup>
                            <Address name="address" onChange={(address) => this.handleAddressChange(address)} />
                        </FormGroup>
                    </Col>
                    <Col md={5}>
                        <FormGroup>
                            <Label required>Primary Phone</Label>
                            <div className="form-inline">
                                <PhoneBox name="primaryPhone" required />
                            </div>
                        </FormGroup>
                        <FormGroup>
                            <Label>Secondary Phone</Label>
                            <div className="form-inline">
                                <PhoneBox name="secondaryPhone" />
                            </div>
                        </FormGroup>
                        <FormGroup>
                            <Label required>Email</Label>
                            <EmailBox
                                name="email"
                                placeholder="Email"
                                maxLength={255}
                                required />
                        </FormGroup>
                        { (!this.state.adding && this.state.form.userTypeCode  === 'CER') &&
                            <React.Fragment>
                                <FormGroup>
                                    <Label>Companies Notifications</Label>
                                    <CompanyMultiselect name="subscribedCompanies"
                                        height={180} companies={this.state.form.subscribedAssociatedCompanies}/>
                                </FormGroup>
                            </React.Fragment>
                        }
                        { (!this.state.adding && this.state.form.userTypeCode  === 'SPN') &&
                            <React.Fragment>
                                <FormGroup>
                                    <Label htmlFor="userSubscribed">
                                        Receive email notifications?
                                        {this.state.form.userSubscribedDisabled ?
                                            <React.Fragment>
                                                &nbsp;&nbsp;
                                                <OverlayTrigger placement="right" overlay={sponsorUnsubscribedTooltip}>
                                                    <FontAwesomeIcon icon={faInfoCircle} size="1x" className="tooltipIcon" />
                                                </OverlayTrigger>
                                            </React.Fragment>
                                        :null}
                                    </Label>
                                    <Switch name='userSubscribed' 
                                        labelLeft="No" 
                                        labelRight="Yes" 
                                        disabled={this.state.form.userSubscribedDisabled}
                                        bsStyle='success' />
                                </FormGroup>
                            </React.Fragment>
                        }
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <Label required>User Type</Label>
                            <UserTypeCombo name="userTypeCode" required
                                disabled={!this.state.adding} />
                        </FormGroup>
                        <FormGroup>
                            <Label required>Roles</Label>
                            <RoleMultiselect name="roles"
                                height={180} userTypeCode={this.state.form.userTypeCode} />
                        </FormGroup>
                        { (!this.state.adding && this.state.form.userTypeCode  === 'CER') &&
                            <React.Fragment>
                                <FormGroup>
                                    <Label>Associated Companies</Label>
                                    <CompanyMultiselect name="companies"
                                        height={180} companies={this.state.form.associatedCompanies}/>
                                </FormGroup>
								<Button type="button" bsStyle="link" onClick={this.onCompanyAssociationClick}>
                                    Associate Company
								</Button>
                            </React.Fragment>
                        }
                        { (!this.state.adding && this.state.form.userTypeCode  === 'SPN') &&
                            <React.Fragment>
                                <FormGroup>
                                    <Label>Associated Corporate Member</Label>
                                    <SponsorMultiselect name="sponsors"
                                        disabled={true}
                                        height={80} sponsors={this.state.form.associatedSponsors}/>
                                </FormGroup>
                            </React.Fragment>
                        }
                        <CompanyAssociationPopUp
                            visible={this.state.showCompanyAssociationPopUp}
                            userId={this.props.selectedId}
                            onSave={this.onCompanyAssociationAdd}
                            onClose={this.onCompanyAssociationClose}/>
                    </Col>
                    <Col md={1}>
                        <FormGroup style={{ marginTop: "180px" }}>
                            {!this.state.form.registrationPending && <CheckBox name="active" label="Active" />}
                        </FormGroup>
                    </Col>
                </Row>
                {!this.state.adding && this.state.form.registrationPending &&
                    <Row>
                        <FormGroup bsClass="col-md-10">
                            <Remark message="(*) This user has not completed registration yet." />
                        </FormGroup>
                    </Row>
                }
                {!this.state.adding && this.state.form.blocked &&
                    <Row>
                        <FormGroup bsClass="col-md-10">
                            <Remark message="(*) This user is currently BLOCKED for exceeding the maximum number of login/reset attempts." />
                        </FormGroup>
                    </Row>
                }
            </React.Fragment>
        )
    }
}

export default UserInfoTab;



// WEBPACK FOOTER //
// ./src/areas/admin/userSetup/userInfo/UserInfoTab.js